import React, { useEffect, useRef, useState } from "react";
import NavRouter from "./router/NavRouter";
import "./App.css";

import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css/animate.min.css";
import "./style.css";
import "./responsive.css";
import SEO from "./helper/SEO";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import { BaseUrl } from "./helper/BaseUrl";
import { ModalProvider } from './contexts/ModalContext';
import { fetchJson } from './helper/fetchJson';


function App({ initialData, initialSeo, initialGlobalSchema }) {
  const [seoData, setSeoData] = useState(initialSeo || null);
  const [globalSchema, setGlobalSchema] = useState(initialGlobalSchema || null);
  const location = useLocation();
  const initialPath = useRef(location.pathname);
  const routeInitialData = location.pathname === initialPath.current ? initialData : undefined;

  useEffect(() => {
    let active = true;

    if (initialSeo && location.pathname === initialPath.current) {
      setSeoData(initialSeo);
      return undefined;
    }

    fetchJson(`${BaseUrl}/api/seo-by-url${location.pathname}`)
      .then((result) => {
        if (active && result.seo !== false) {
          setSeoData(result.seo || null);
        }
      })
      .catch((error) => {
        console.error('Fetch error:', error.message);
      });

    return () => {
      active = false;
    };
  }, [location.pathname, initialSeo])

  useEffect(() => {
    let active = true;

    if (initialGlobalSchema) {
      return undefined;
    }

    fetchJson(`${BaseUrl}/api/schema-management`)
      .then((result) => {
        if (active) {
          setGlobalSchema(result.schema || null);
        }
      })
      .catch((error) => {
        console.error('Schema fetch error:', error.message);
      });

    return () => {
      active = false;
    };
  }, [initialGlobalSchema]);

  useEffect(() => {
    let idleId;
    let timerId;
    let active = true;

    const initializeAnimations = () => {
      import("wowjs").then(({ WOW }) => {
        if (!active) return;
        const wow = new WOW({
          live: false,
          mobile: true,
        });
        wow.init();
      });
    };

    const scheduleAnimations = () => {
      if ("requestIdleCallback" in window) {
        idleId = window.requestIdleCallback(initializeAnimations, { timeout: 3000 });
      } else {
        timerId = window.setTimeout(initializeAnimations, 1500);
      }
    };

    if (document.readyState === "complete") scheduleAnimations();
    else window.addEventListener("load", scheduleAnimations, { once: true });

    return () => {
      active = false;
      window.removeEventListener("load", scheduleAnimations);
      if (idleId) window.cancelIdleCallback(idleId);
      if (timerId) window.clearTimeout(timerId);
    };
  }, []);

  useEffect(() => {
    if (document.getElementById("font-awesome-runtime")) return undefined;

    const timerId = window.setTimeout(() => {
      const script = document.createElement("script");
      script.id = "font-awesome-runtime";
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/js/all.min.js";
      script.defer = true;
      document.head.appendChild(script);
    }, 5000);

    return () => window.clearTimeout(timerId);
  }, []);

  return (
    <div className="App">
      <SEO seoData={seoData} globalSchema={globalSchema} pathname={location.pathname}/>
       <ModalProvider>
      <NavRouter initialData={routeInitialData}/>
      </ModalProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
